import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";

export const ReportsPage = (): React.ReactNode => {
  const { accountId } = useParams();
  const navigate = useNavigate();

  const reports = [
    {
      title: 'Summary Report',
      description: 'View overall trading statistics including orders count, profit by pair, and monthly performance',
      path: 'summary',
    },
    {
      title: 'End of Year Summary',
      description: 'Generate yearly reports with monthly breakdown and comprehensive statistics',
      path: 'eoy-summary',
    },
    {
      title: 'Monthly Drill-Down',
      description: 'View detailed order breakdown for a specific month with closed and open orders',
      path: 'monthly-drilldown',
    },
    {
      title: 'Yearly Tax Report',
      description: 'Comprehensive tax report including trading performance and fund movements for the year',
      path: 'tax-report',
    },
  ];

  return (
    <div className="grid gap-6">
      <div>
        <h1 className="text-3xl font-bold">Reports</h1>
        <p className="text-muted-foreground mt-2">
          View and generate trading reports and analytics
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {reports.map((report) => (
          <Card
            key={report.path}
            className="cursor-pointer hover:bg-accent transition-colors"
            onClick={() => navigate(`/account/${accountId}/reports/${report.path}`)}
          >
            <CardHeader>
              <CardTitle>{report.title}</CardTitle>
              <CardDescription>{report.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-sm text-muted-foreground">
                Click to view report →
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
